import moment from 'moment';
import { Expression, NamedColumn } from '../../../types';

export default function overdueHandler(
  column: NamedColumn, expression: Expression,
): Expression {
  const today = moment().clone().startOf('day').format('YYYY-MM-DD HH:mm:ss');

  return {
    ...expression, field: column.identifier(), operator: 'date_before', value: [today],
  };
}
